// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".small-loader{position:relative}.small-loader>div{border:4px solid #f3f3f3;border-top:4px solid #09f;border-radius:50%;height:20px;width:20px;animation:loader-spin .5s linear infinite}", ""]);
// Exports
module.exports = exports;
